export interface GlobalEDataCookie {
  countryISO: string;
  currencyCode: string;
  cultureCode: string;
}

export const GLOBAL_E_CULTURE_CODE = '3';

export const buildGlobalEDataCookie = (
  countryISO: string,
  currencyCode: string,
): GlobalEDataCookie => ({
  countryISO,
  currencyCode,
  cultureCode: GLOBAL_E_CULTURE_CODE,
});
